
export default {
  fetchOnServer: false,

  props: {
    fetchItem: {
      type: [Number, String],
      default: 5,
    },
  },

  data () {
    return {
      data: null,
    }
  },

  async fetch () {
    await this.fetchApi(this.currentPage)
  },

  computed: {
    news () {
      if (!this.data) {
        return null
      }

      return this.data.results
    },

    id () {
      return this.$nuxt.context.route.params.id
    },
  },

  methods: {
    getNewName (url) {
      if (!url) {
        return ''
      }

      const companyName = url
        .split('/')
        .pop()
        .replace('.chn', '.html')
      return companyName
    },

    getUrl ({ original_url, id }) {
      const newName = this.getNewName(original_url)
      return `/news/${id}/${newName}`
    },

    async fetchApi () {
      const response = await this.$axios.request({
        url: '/api/news/',
        method: 'get',
        params: {
          newest: this.fetchItem, // 5 days ago
          ignore: this.id,
        },
      })

      this.data = response?.data
    },
  },

}
